import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { RankingsRoutingModule } from './rankings-routing.module';
import { RankingsListComponent } from './rankings-list/rankings-list.component';
import { RankingsCreateComponent } from './rankings-create/rankings-create.component';

@NgModule({
  declarations: [RankingsListComponent, RankingsCreateComponent],
  imports: [
    CommonModule,
    RankingsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class RankingsModule { }
